import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProjectCurrentUsage } from "../types";

export const getProjectCurrentUsage = ({
  billingProfileId,
  projectId
}: {
  billingProfileId: string;
  projectId: string;
}) => {
  return apiProxyRequest<ProjectCurrentUsage>(
    `/billing/profiles/${billingProfileId}/projects/${projectId}/current_usage`
  );
};
